import createIcon from '../../createIcon';

/**
 * @component @name Sixtyfps
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgOFYxNkgxNVY4SDE5Wk0xOSA1SDE1QzEzLjM0IDUgMTIgNi4zNCAxMiA4VjE2QzEyIDE3LjY2IDEzLjM0IDE5IDE1IDE5SDE5QzIwLjY2IDE5IDIyIDE3LjY2IDIyIDE2VjhDMjIgNi4zNCAyMC42NiA1IDE5IDVaTTEwIDhWNUg1QzMuMzQgNSAyIDYuMzQgMiA4VjE2QzIgMTcuNjYgMy4zNCAxOSA1IDE5SDhDOS42NiAxOSAxMSAxNy42NiAxMSAxNlYxM0MxMSAxMS4zNCA5LjY2IDEwIDggMTBINVY4SDEwWk04IDEzVjE2SDVWMTNIOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Sixtyfps = createIcon('Sixtyfps', [
  [
    'path',
    {
      d: 'M19 8V16H15V8H19ZM19 5H15C13.34 5 12 6.34 12 8V16C12 17.66 13.34 19 15 19H19C20.66 19 22 17.66 22 16V8C22 6.34 20.66 5 19 5ZM10 8V5H5C3.34 5 2 6.34 2 8V16C2 17.66 3.34 19 5 19H8C9.66 19 11 17.66 11 16V13C11 11.34 9.66 10 8 10H5V8H10ZM8 13V16H5V13H8Z',
      key: 'iygmph',
    },
  ],
]);

export default Sixtyfps;
